import React from 'react';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo" onClick={scrollToTop}>IA</div>
            <p className="footer-tagline">Building innovative solutions with AI</p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4 className="footer-title">Quick Links</h4>
              <div className="footer-nav">
                <a href="#about" className="footer-link">About</a>
                <a href="#projects" className="footer-link">Projects</a>
                <a href="#skills" className="footer-link">Skills</a>
                <a href="#experience" className="footer-link">Experience</a>
                <a href="#hobbies" className="footer-link">Hobbies</a>
              </div>
            </div>

            <div className="footer-section">
              <h4 className="footer-title">Connect</h4>
              <div className="footer-social">
                <a href="https://github.com/Iannis863" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                  <Github size={20} />
                </a>
                <a href="https://www.linkedin.com/in/iannis-alb-502791354/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                  <Linkedin size={20} />
                </a>
                <a href="mailto:iannisalb007@gmail.com" className="footer-social-link">
                  <Mail size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Iannis Alb. Designed & Built with <Heart size={14} className="heart-icon" /> by Iannis
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;